import React, { useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';

import { Typography } from '@material-ui/core';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';
import api from '~/services/api';

export default function Recognize({ close, sending, onForm }) {
  const handleRecognizeAll = useCallback(async () => {
    try {
      await api.put('/alarmessistemas/reconhecetodos');

      toast.success(t('s.geral.alertasistema.alarmesreconhecidos'));

      await onForm();
      await close();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [close, onForm]);

  useEffect(() => {
    if (sending) handleRecognizeAll();
  }, [sending]);

  return (
    <Typography>
      {t('s.geral.alertasistema.msgconfirmacaoreconhecer')}
    </Typography>
  );
}

Recognize.propTypes = {
  close: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
};
